<template>
<div>
  <team-audit :type="1" v-if="$route.query.diff == '1'"></team-audit>
  <team-accomplish :type="1" :diff="$route.query.diff" v-else :examine="true"></team-accomplish>
</div>
</template>

<script>
import TeamAudit from "components/TeamAudit";
import TeamAccomplish from "components/TeamAccomplish";
export default {
  name: "Audited",
  components: {
    TeamAudit,
    TeamAccomplish
  }
}
</script>

<style scoped>

</style>
